import { useQuery } from "@tanstack/react-query";
import { getSubproperties } from "../api";

export const useSubpropertiesQuery = ({ uid }: { uid?: string }) => {
  const query = useQuery({
    queryKey: ["sub-properties", uid],
    queryFn: () => getSubproperties(uid),
    enabled: !!uid,
    select: (data) => {
      if (!data) return undefined;
      return data.data;
    },
  });

  return { ...query, data: query.data };
};
